

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { Getter, namespace } from "vuex-class"

import vSelect from "vue-select"
// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"

import { Rule, RuleAction, ActionTypeLabel, actionTypeLabels, actionSettingsForActionType, Field, dataTypeByFieldType, ActionType, Recipient, RecipientType } from "@/types"
import { DataType, Operator, operatorLabels, operatorsByFieldType } from "@/types/insights"
import { CaseColumn, caseColumns } from "@/types/caseColumns"

import RuleActionsSettings from "@/components/Config/Rules/RuleActionsSettings.vue"
import { IntegrationOutOption } from "@/types/integration"
import Guid from "@/scripts/guid"
import { TenantFeatures } from "@/types/tenantFeatures"
import { Format } from "@/types/format"
import ValidationMixin from "@/mixins/validationMixin"
import { mixins } from "vue-class-component"

const setup = namespace("setup")

@Component({
	components: {
		"v-select": vSelect,
		"rule-actions-settings": RuleActionsSettings,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class RuleActions extends mixins(ValidationMixin) {
	@Prop({ default: null })
	public rule!: Rule

	@Prop({ type: Boolean, default: true })
	public canEdit!: boolean;

	@Prop({ default: () => [] })
	private integrationOuts!: IntegrationOutOption[]

	@Prop({ default: () => () => [] })
	private formatsGet!: () => Promise<Format[]>

	@Getter("getIsFeatureEnabled") getIsFeatureEnabled!: (feature: TenantFeatures) => boolean

	@setup.State fields!: Field[];

	@setup.Getter("getFieldsForRuleActions") fieldsForRuleActions!: CaseColumn[]

	private actionTypes: ActionTypeLabel[] = actionTypeLabels;

	public get columns () {
		return [
			{
				key: "label",
				label: "Title"
			},
			{
				key: "actionType",
				label: "Action Type"
			},
			{
				key: "settings",
				label: "Settings"
			},
			{
				key: "",
				label: ""
			}
		]
	}

	public get enabledActionTypes (): ActionTypeLabel[] {
		return this.actionTypes.filter(t => !t.requireFeature || this.getIsFeatureEnabled(t.requireFeature!))
	}

	public addAction () {
		// Create new dummy action and add it to the list of actions
		let newAction: RuleAction

		const settings: {[key: string]: string} = {}
		settings["field"] = ""
		settings["newValue"] = ""
		settings["newValueLabel"] = ""
		settings["fieldDataType"] = ""

		newAction = {
			id: null,
			key: Guid.newGuid(),
			label: "",
			actionType: 0,
			settings: settings
		}

		this.rule.actions.push(newAction)
	}

	public removeAction (action: RuleAction) {
		if (!this.rule) {
			return
		}

		this.rule.actions.removeWhere(a => a === action)
	}

	public actionTypeSelected (actionType: ActionType, action: RuleAction) {
		if (action) {
			Vue.set(action, "actionType", actionType)
		}
	}

	public addActionButtonDisabled () : boolean {
		if (this.rule.actions.length === 0) {
			return false
		}

		this.$emit(this.ruleActionsValid ? "valid" : "invalid")

		return !this.ruleActionsValid
	}

	public get ruleActionsValid (): boolean {
		return this.rule.actions.length > 0 && !this.rule.actions.some(action =>
			action.label.length === 0 ||
			this.validationActionHasInvalidDirectEmailRecipient(action)
		)
	}

	private validationActionHasInvalidDirectEmailRecipient (action: RuleAction): boolean {
		const recipientList = "recipientList" in action.settings ? action.settings["recipientList"] as Recipient[] : null

		return action.actionType === ActionType.SendEmail &&
			!!recipientList &&
			recipientList.some(rec =>
				rec.type === RecipientType.EmailAddress &&
				(!this.emailFormatIsValid(rec.emailAddress) || (rec.name?.length === 0 ?? false))
			)
	}
}

